import { Component, Input, Output, EventEmitter, computed } from '@angular/core';

/**
 * Accessible modal dialog with backdrop, configurable width, and optional title bar.
 */
@Component({
  selector: 'es-modal',
  template: `
    @if (open) {
      <div
        class="fixed inset-0 z-[1000] flex items-center justify-center bg-black/70 animate-fade-in"
        (click)="handleBackdropClick()"
      >
        <div
          [class]="panelClasses()"
          [style.max-height]="maxHeight"
          (click)="$event.stopPropagation()"
        >
          @if (title) {
            <div class="flex items-center justify-between px-6 py-4 border-b border-[var(--border)]">
              <h2 class="text-xl font-semibold">{{ title }}</h2>
              <button
                class="text-[var(--text-secondary)] hover:text-[var(--text)] text-lg cursor-pointer"
                (click)="close()"
              >✕</button>
            </div>
          }
          <div class="overflow-auto">
            <ng-content></ng-content>
          </div>
        </div>
      </div>
    }
  `,
})
export class ModalComponent {
  @Input() open = false;
  @Input() title: string | null = null;
  @Input() width: 'sm' | 'md' | 'lg' | 'xl' = 'md';
  @Input() maxHeight: string | null = '85vh';
  @Input() closeOnBackdrop = true;
  @Output() closed = new EventEmitter<void>();

  panelClasses = computed(() => {
    const base = 'bg-[var(--bg-card)] rounded-2xl border border-[var(--border)] shadow-2xl overflow-hidden animate-scale-in';
    const widths = { sm: 'w-full max-w-md', md: 'w-full max-w-lg', lg: 'w-full max-w-2xl', xl: 'w-full max-w-4xl' };
    return `${base} ${widths[this.width]}`;
  });

  handleBackdropClick() {
    if (this.closeOnBackdrop) this.close();
  }

  close() {
    this.closed.emit();
  }
}
